const HOUSE_NUMBER_ALLOWED_CHARACTERS_REGEX = /[^0-9A-Za-z\s/-]/g;
const MULTIPLE_SPACES_REGEX = /\s+/g;

export const HOUSE_NUMBER_MAX_LENGTH = 45;
export const POSTAL_CODE_MAX_LENGTH = 10;

export const sanitizeHouseNumber = (value: string): string => {
  return value
    .replace(HOUSE_NUMBER_ALLOWED_CHARACTERS_REGEX, "")
    .replace(MULTIPLE_SPACES_REGEX, " ")
    .trim()
    .slice(0, HOUSE_NUMBER_MAX_LENGTH);
};

export const sanitizePostalCode = (value: string): string => {
  return value.replace(/\D/g, "").slice(0, POSTAL_CODE_MAX_LENGTH);
};
